import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import * as Icon from 'react-bootstrap-icons';

function SettingsPane(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button style={{fontSize: '1.2em'}} variant="secondary" className="float-start settings-menu-toggle" onClick={handleShow}>
        <Icon.Gear />
      </Button>

      <Offcanvas show={show} onHide={handleClose} className="settings-offcanvas">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{props.title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        { props.children }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default SettingsPane;